import { collection, addDoc, getDocs, query, where, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

const COLLECTION = 'course_messages';

/**
 * Fetch ALL messages for the current user (for Messages page: full threads with course owner).
 */
export async function getMyMessages(userId) {
  if (!userId) return [];
  const q = query(
    collection(db, COLLECTION),
    where('userId', '==', userId)
  );
  const snap = await getDocs(q);
  const list = [];
  snap.forEach((docSnap) => {
    const d = docSnap.data();
    list.push({
      id: docSnap.id,
      courseId: d.courseId || '',
      courseTitle: d.courseTitle || '',
      message: d.message || '',
      adminReply: d.adminReply || null,
      adminReplyAt: d.adminReplyAt || null,
      status: d.status || 'pending',
      createdAt: d.createdAt || null,
    });
  });
  list.sort((a, b) => {
    const ta = a.createdAt?.toMillis?.() ?? 0;
    const tb = b.createdAt?.toMillis?.() ?? 0;
    return tb - ta;
  });
  return list;
}

/**
 * Fetch messages for the current user that have an admin reply (for notifications).
 */
export async function getMyMessagesWithReplies(userId) {
  if (!userId) return [];
  const q = query(
    collection(db, COLLECTION),
    where('userId', '==', userId)
  );
  const snap = await getDocs(q);
  const list = [];
  snap.forEach((docSnap) => {
    const d = docSnap.data();
    if (d.adminReply != null && String(d.adminReply).trim() !== '') {
      list.push({
        id: docSnap.id,
        courseId: d.courseId || '',
        courseTitle: d.courseTitle || '',
        adminReply: d.adminReply || '',
        adminReplyAt: d.adminReplyAt || null,
        status: d.status || 'pending',
      });
    }
  });
  list.sort((a, b) => {
    const ta = a.adminReplyAt?.toMillis?.() ?? 0;
    const tb = b.adminReplyAt?.toMillis?.() ?? 0;
    return tb - ta;
  });
  return list;
}

/**
 * Send a message from a user to the course owner (e.g. after payment).
 * @param {Object} params
 * @param {string} params.courseId - Course document ID
 * @param {string} params.courseTitle - Course title (for owner reference)
 * @param {string} params.userId - Firebase Auth UID
 * @param {string} params.userEmail - User email
 * @param {string} params.userName - User display name
 * @param {string} params.message - Message text
 */
export async function sendCourseMessage({ courseId, courseTitle, userId, userEmail, userName, message }) {
  const ref = await addDoc(collection(db, COLLECTION), {
    courseId,
    courseTitle: courseTitle || '',
    userId,
    userEmail: userEmail || '',
    userName: userName || '',
    message: (message || '').trim(),
    status: 'pending',
    adminReply: null,
    adminReplyAt: null,
    createdAt: serverTimestamp(),
  });
  return ref.id;
}
